import React, { useEffect, useState } from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import {
  Box,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  useToast,
} from "@chakra-ui/react";
import { FaSearch } from "react-icons/fa";

const containerStyle = {
  width: "auto",
  height: "400px",
};

interface LatLng {
  lat: number;
  lng: number;
}

function Map({
  value,
  onChange,
}: {
  value?: LatLng;
  onChange: (x: LatLng) => void;
}) {
  const toast = useToast();
  const [center, setCenter] = useState(
    value || { lat: 27.7399474, lng: 85.3068864 }
  );

  function success(position: any) {
    const lat = position.coords.latitude;
    const lng = position.coords.longitude;

    setCenter({ lat, lng });
  }

  useEffect(() => {
    if (navigator.geolocation && !value)
      navigator.geolocation.getCurrentPosition(success);
  }, []);

  useEffect(() => {
    onChange(center);
  }, [onChange, center]);

  const searchRef = React.useRef<any>();

  async function search() {
    let coder = new (window as any).google.maps.Geocoder();
    coder.geocode(
      { address: searchRef.current?.value },
      function (results: any, status: string) {
        if (status === "OK") {
          setCenter({
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng(),
          });
        } else {
          toast({
            status: "error",
            title: "Geocode was not successful",
            description:
              "Geocode was not successful for the following reason: " + status,
            duration: 3000,
            isClosable: true,
          });
        }
      }
    );
  }

  return (
    <Box position="relative" height="400px">
      <InputGroup size="md" position="absolute" maxW="400px" top={2} left={2}>
        <Input
          bg="white"
          zIndex="2"
          placeholder="Search Location..."
          border="2px solid"
          borderColor="teal.400"
          ref={searchRef}
          onKeyPress={(e) => {
            e.stopPropagation();
            if (e.key.toLowerCase() === "enter") {
              e.preventDefault();
              search();
            }
          }}
        />
        <InputRightElement>
          <IconButton
            aria-label="search"
            icon={<FaSearch />}
            onClick={search}
          />
        </InputRightElement>
      </InputGroup>

      <LoadScript
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""}
      >
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          options={{
            mapTypeControl: false,
            fullscreenControl: false,
            streetViewControl: false,
          }}
          zoom={12}
        >
          <>
            <Marker
              draggable={true}
              position={center}
              onDragEnd={(e) =>
                onChange({ lat: e.latLng.lat(), lng: e.latLng.lng() })
              }
            />
          </>
        </GoogleMap>
      </LoadScript>
    </Box>
  );
}

export default React.memo(Map);
